export class Prima_Infantil{
    constructor(
        public diverso: Number,
        public nombre_hijo: String,
        public fecha_nacimiento: String,

    ){}
}